<style lang="less">

.wx-subpage{
    position:relative;
    width:100%;
    height:100%;

    .subbar{
        height:53px;
        border-bottom:1px solid #d8d8d8;
        background:#f5f5f5;
		
		.wrap{
            width:1080px; 
            margin:auto;
        }

		//覆盖组件样式
		.wx-menutab .wx-menutab-items{height:51px;}
		.wx-menutab-item{ margin-right:20px; padding:15px 0px;text-decoration:none;font-size:14px;color:#737373; }
		.wx-menutab-item-active{color:#333;}
		.wx-menutab-active{height:2px;}
    }
    
    .page-wrap{
        position:relative;
        overflow:hidden;
        clear:both;
    }

}
</style>
<template lang="html">
	<div class="wx-subpage">

        <div class="subbar">
			<div class="wrap">
				<wx-menutab :menus="menus" :activeKey="activeKey" :lazy="lazy" @clickMenu="clickMenu"></wx-menutab>
			</div>
		</div>

		<div class="page-wrap" :style="pageWrapStyle">
			<slot></slot>
		</div>
	</div>
</template>

<script>

export default {
    components: {

    },
    props : {
        //菜单数据
        menus : {
			type: Array,
			default : function(){
				return [];
			}
        },
        //当前勾选的菜单索引
        activeKey:{
            type:String,
            default:''
        },
        //是否延迟切换模式
        lazy:{
            type:Boolean,
            default:false
        }
	},
	// mixins: [pageMaxin],
    data:function(){
        return {
        }
    },
    components: {

    },
    mounted(){
		
	},
	computed:{
		pageWrapStyle:function(){
			return{
				'height':(this.$store.state.indexConH-53)+'px'
			}
        }
	},
	methods: {
        //点击子菜单
		clickMenu:function(key,name,index){
            this.$emit('clickMenu',key,name,index);
		}
    },
    watch:{

    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Subpage.vue